import { render } from "./ItemIndexDemandReservation.vue?vue&type=template&id=503f56da&scoped=true"
import script from "./ItemIndexDemandReservation.vue?vue&type=script&lang=js"
export * from "./ItemIndexDemandReservation.vue?vue&type=script&lang=js"

import "./ItemIndexDemandReservation.vue?vue&type=style&index=0&id=503f56da&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-503f56da"

export default script